import React from 'react'
import Skeleton from '@material-ui/lab/Skeleton';
import { safeDeepGetWithType } from 'iotera-base/json';

export function Loading(props) {
    // TODO Configure loading for lazy loader
    return <div className='centeringItem' style={{ minWidth: '100%', fontStyle: 'italic' }}>Loading...</div>;
}

export function SuspenseLoading(props) {
    const { height } = props
    const width = safeDeepGetWithType(props, ['width'], '100%')
    const position = safeDeepGetWithType(props, ['position'], 'left');
    let right = null;
    let left = null;
    if (position === 'right') {
        right = 0
    } else if (position === 'left') {
        left = 0
    }
    return (
        <React.Fragment >
            <Skeleton variant="rect" width={width} height={height} style={{ position: 'absolute', right, left }} />
        </React.Fragment>
    )
}

export function EmptyLoading(props) {
    return <div />;
}